import React from "react";

export function KonattuLogo({ className = "h-16", showTagline = true }) {
  return (
    <div className={`flex flex-col items-center ${className ? "" : ""}`}>
      <img
        src="/konattu-logo.png"
        alt="Konattu Group"
        className={`${className} w-auto object-contain`}
        data-testid="konattu-logo"
      />
      {showTagline && (
        <p className="mt-3 text-sm md:text-base text-neutral-600 tracking-wide">
          Your Quality Shopping Partner
        </p>
      )}
    </div>
  );
}
